import qs from "qs";

const parse = (url, options) => qs.parse(url, {ignoreQueryPrefix: true, ...options});

const stringify = (data, options) => qs.stringify(data, {addQueryPrefix: true, ...options});

export default {parse, stringify};
